export default __webpack_public_path__ + "static/media/mail.797da48a.svg";